import CartContextContainer from 'components/booking/context/cartContext'
import LoginContextContainer from 'components/login/loginContext'
import StaylistFetchContextContainer from 'components/common/staylistFetchContext'
import AvailabilityContextContainer from 'components/booking/context/availabilityContext'
import BlissContextContainer from 'components/bliss/blissContext'

export const wrapRootElement = ({ element }) =>
  <BlissContextContainer>
    <StaylistFetchContextContainer>
      <LoginContextContainer>
        <CartContextContainer>
          <AvailabilityContextContainer>
            {element}
          </AvailabilityContextContainer>
        </CartContextContainer>
      </LoginContextContainer>
    </StaylistFetchContextContainer>
  </BlissContextContainer>
